import React from 'react';
import { Flex } from '../../../../components/Flex';
import { Link } from '@/wag-react/core-components/link';
import { Box } from '../../../../components/Box';
import { Typography } from '../../../../components/Typography';
import { petResourcesDataDesktop } from './data';
import { ArrowIcon } from './ArrowIcon';

// Reusable Resource Card Component
const ResourceCard = ({
  url,
  title,
  image
}) => <Box key={title} width="230px" mb={3} data-sentry-element="Box" data-sentry-component="ResourceCard" data-sentry-source-file="PetResourceCenter.tsx">
    <Link href={url} style={{
    cursor: 'pointer',
    display: 'block'
  }} data-sentry-element="Link" data-sentry-source-file="PetResourceCenter.tsx">
      <Box display="flex" width="100%" height="70px" alignItems="center" borderRadius="8px" bg="white" boxShadow="0px 2px 8px 0px rgba(0, 0, 0, 0.15)" overflow="hidden" hover data-sentry-element="Box" data-sentry-source-file="PetResourceCenter.tsx">
        <Box width="71px" height="100%" display="flex" alignItems="center" justifyContent="center" backgroundImage={`url(${image})`} backgroundSize="cover" backgroundPosition="center" data-sentry-element="Box" data-sentry-source-file="PetResourceCenter.tsx" />

        <Typography color="midnightBlack" fontSize="14px" fontWeight={600} lineHeight="28px" fontFamily="'Hero New', sans-serif" pl={2} style={{
        cursor: 'pointer'
      }} data-sentry-element="Typography" data-sentry-source-file="PetResourceCenter.tsx">
          {title}
        </Typography>
      </Box>
    </Link>
  </Box>;
export const PetResourceCenter = () => {
  // Flatten the nested arrays into a single array for grid layout
  const flattenedData = petResourcesDataDesktop.flat();
  return <Flex width={1} boxSizing="border-box" flexDirection="column" marginBottom="50px" mt={4} data-sentry-element="Flex" data-sentry-component="PetResourceCenter" data-sentry-source-file="PetResourceCenter.tsx">
      <Box px={[3, 3, 0]} data-sentry-element="Box" data-sentry-source-file="PetResourceCenter.tsx">
        <Typography variant="h2" color="midnightBlack" mb={0} textAlign={['left', 'left', 'center']} width={1} fontSize={['26px', '26px', '36px']} lineHeight={['34px', '34px', '44px']} fontWeight={700} fontFamily="'Hero New', sans-serif" data-sentry-element="Typography" data-sentry-source-file="PetResourceCenter.tsx">
          Pet resource center
        </Typography>
        <Typography variant="body2" color="charcoal" textAlign={['left', 'left', 'center']} width={1} fontSize={['14px', '14px', '16px']} lineHeight={['20px', '20px', '24px']} fontWeight={400} fontFamily="'Hero New', sans-serif" mt={2} data-sentry-element="Typography" data-sentry-source-file="PetResourceCenter.tsx">
          Expert info, helpful tools, and tailored insights for all aspects of pet ownership. 
        </Typography>
      </Box>
      
      {/* Desktop Grid Layout - with horizontal scroll if needed */}
      <Box width={1} display={['none', 'none', 'block']} mt={4} mb={4} px={[3, 4]} overflowX="auto" data-sentry-element="Box" data-sentry-source-file="PetResourceCenter.tsx">
        <Flex width="1000px" flexWrap="wrap" justifyContent="space-between" mx="auto" style={{
        minWidth: '1000px'
      }} data-sentry-element="Flex" data-sentry-source-file="PetResourceCenter.tsx">
          {flattenedData.map(resourceData => <ResourceCard key={resourceData.title} {...resourceData} />)}
        </Flex>
      </Box>

      {/* Mobile Version - Same Grid Layout as Desktop */}
      <Box width={1} display={['block', 'block', 'none']} mt={4} mb={2} px={[3, 4]} overflowX="auto" data-sentry-element="Box" data-sentry-source-file="PetResourceCenter.tsx">
        <Box width="1000px" mx="auto" data-sentry-element="Box" data-sentry-source-file="PetResourceCenter.tsx">
          <Flex flexWrap="wrap" justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="PetResourceCenter.tsx">
            {flattenedData.map(resourceData => <ResourceCard key={resourceData.title} {...resourceData} />)}
          </Flex>
        </Box>
      </Box>

      <Box width={1} mb={1} px={[3, 3, 0]} data-sentry-element="Box" data-sentry-source-file="PetResourceCenter.tsx">
        <Flex width={1} justifyContent={['flex-start', 'flex-start', 'center']} flexDirection={['column', 'column', 'row']} alignItems={['flex-start', 'flex-start', 'center']} data-sentry-element="Flex" data-sentry-source-file="PetResourceCenter.tsx">
          <Flex alignItems="center" mb={[2, 2, 0]} mr={[0, 0, 3]} data-sentry-element="Flex" data-sentry-source-file="PetResourceCenter.tsx">
            <Link href="/wag-wellness/wellness-plans" color="wagBlue" data-sentry-element="Link" data-sentry-source-file="PetResourceCenter.tsx">
              <Flex alignItems="start" data-sentry-element="Flex" data-sentry-source-file="PetResourceCenter.tsx">
                <Typography color="#2866D3" fontSize="18px" style={{
                fontFamily: '"Hero New", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                fontWeight: 700,
                cursor: 'pointer'
              }} data-sentry-element="Typography" data-sentry-source-file="PetResourceCenter.tsx">
                  Wag! Wellness
                </Typography>
                <ArrowIcon size={24} color="#275FC2" className="mt-[1px]" data-sentry-element="ArrowIcon" data-sentry-source-file="PetResourceCenter.tsx" />
              </Flex>
            </Link>
          </Flex>
          
          <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="PetResourceCenter.tsx">
            <Link href="/wag-wellness/pet-insurance" color="wagBlue" data-sentry-element="Link" data-sentry-source-file="PetResourceCenter.tsx">
              <Flex alignItems="start" data-sentry-element="Flex" data-sentry-source-file="PetResourceCenter.tsx">
                <Typography color="#2866D3" fontSize="18px" style={{
                fontFamily: '"Hero New", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                fontWeight: 700,
                cursor: 'pointer'
              }} data-sentry-element="Typography" data-sentry-source-file="PetResourceCenter.tsx">
                  Pet Insurance Plans
                </Typography>
                <ArrowIcon size={24} color="#275FC2" className="mt-[1px]" data-sentry-element="ArrowIcon" data-sentry-source-file="PetResourceCenter.tsx" />
              </Flex>
            </Link>
          </Flex>
        </Flex>
      </Box>
    </Flex>;
};